import React, { useState, useEffect } from 'react';

const NewsSection = ({ className }) => {
  const [newsArticles, setNewsArticles] = useState([]);
  const [error] = useState(null);

  // ✅ Helper to strip HTML tags from content
  const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/news-events?status=published&limit=3`);
        if (response.ok) {
          const data = await response.json();
          setNewsArticles(data.events);
        }
      } catch (error) {
        console.error('Error fetching news:', error);
      }
    };
    fetchNews();
  }, []);

  return (
    <section className={`py-16 px-4 bg-gray-50 ${className}`}>
      <div className="container mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#364A9A] text-center mb-8 sm:mb-12 font-poppins">
          Our Latest News
        </h2>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        {newsArticles.length === 0 && !error && (
          <p className="text-center text-gray-500 text-sm sm:text-base">No news for now. Check back later.</p>
        )}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {newsArticles.map((article) => {
            // ✅ Clean and shorten the content for preview
            const previewText = stripHtml(article.content).substring(0, 100);

            return (
              <div
                key={article.id}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 ease-in-out transform hover:-translate-y-1"
              >
                <div className="relative">
                  {article.images && article.images.length > 0 && (
                    <img
                      src={`http://localhost:5000${article.images[0].imageUrl}`}
                      alt={article.title}
                      className="w-full h-64 object-cover"
                    />
                  )}
                  <span className="absolute bottom-0 left-0 bg-[#ECEE07] text-gray-900 text-xs font-bold px-3 py-1 rounded-tr-lg">
                    {new Date(article.publishedDate).toLocaleDateString()}
                  </span>
                </div>

                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#364A9A] mb-3 font-poppins">
                    {article.title}
                  </h3>

                  {/* ✅ Display clean, readable text preview */}
                  <p className="text-gray-700 text-base mb-4 font-serif">
                    {previewText}...
                  </p>

                  <a href={`/news/${article.id}`} className="text-[#364A9A] font-semibold hover:underline">
                    READ MORE
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
